import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  signal,
} from '@angular/core';
import { DOCUMENT, NgClass } from '@angular/common';

interface ShareNetwork {
  id: string;
  label: string;
  icon: string;
  href: any;
}

@Component({
  selector: 'app-share-float',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './share-float.html',
  styleUrls: ['./share-float.scss'],
  imports: [NgClass],
})
export class ShareFloat {
  private readonly doc = inject(DOCUMENT);
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  /** URL del PDF; si no se pasa, el botón amarillo no se muestra */
  readonly pdfUrl = input<string | null>(null);

  protected readonly faShareNodes = 'fa fa-share-nodes';
  protected readonly faFilePdf = 'fa fa-file-pdf';
  protected readonly open = signal(false);

  readonly networks: ShareNetwork[] = [
    {
      id: 'facebook',
      label: 'Facebook',
      icon: 'fab fa-facebook',
      href: (u: string) =>
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}`,
    },
    {
      id: 'twitter',
      label: 'Twitter',
      icon: 'fab fa-x-twitter',
      href: (u: string, t: string) =>
        `https://twitter.com/intent/tweet?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}`,
    },
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      icon: 'fab fa-whatsapp',
      href: (u: string, t: string) =>
        `https://wa.me/?text=${encodeURIComponent(`${t} ${u}`)}`,
    },
  ];

  toggle() {
    this.open.update((v) => !v);
  }

  close() {
    this.open.set(false);
  }

  onDocumentClick(event: Event) {
    if (
      this.open() &&
      !this.host.nativeElement.contains(event.target as Node)
    ) {
      this.close();
    }
  }

  share(network: ShareNetwork) {
    // Se lee al hacer clic, así siempre es la ruta actual
    const url = this.doc.location.href;
    const title = this.doc.title;
    this.doc.defaultView?.open(
      network.href(url, title),
      '_blank',
      'noopener,width=600,height=500',
    );
  }
}
